import React from 'react';
import { connect } from 'react-redux';
import { CanvasPrint } from './slide/CanvasPrint';
import storeManager from '../store/StoreManager';
import styles from './AppPrintEditor.scss';
import canvasScale from '../components/utils/CanvasScaleUtils';

const AppPrintEditorWrapper = React.createClass({
    openPrint() {
        setTimeout(function() {
            window.print();
        }.bind(this), 3000);
    },
    render () {
        if (this.props.slides == undefined)
            return <div/>;

        const scaleProperties = canvasScale.getPrintScaleProperties(this.props.windowWidth, this.props.windowHeight);

        let elements = [];
        let slideModel;
        let i;

        const holderStyle = {
            pageBreakAfter: 'always',
            float: 'none'
        };

        for (i = 0; i < this.props.slides.length; i++) {
            slideModel = this.props.slides[i];
            elements.push(<div style={holderStyle} key={'appPrintElements' + i}>
                            <CanvasPrint printTemplate={1} slideModel={slideModel} index={i} dispatch={this.props.dispatch} scaleProperties={scaleProperties} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>
                          </div>);
        }

        this.openPrint();

        return (
            <div id='app' className={styles.app}>
                {elements}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const store = storeManager.getStore();
    const slides = state.production.slides;
    let windowWidth = state.production.windowWidth;
    let windowHeight = state.production.windowHeight;

    if (!(windowWidth > 0))
        windowWidth = window.innerWidth;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    return {
        dispatch: store.dispatch,
        windowWidth,
        windowHeight,
        slides
    };
}

export const AppPrintEditor = connect(mapStateToProps)(AppPrintEditorWrapper);



/** WEBPACK FOOTER **
 ** ./src/components/AppPrintEditor.js
 **/